import React from "react";
import {
  Datagrid,
  Filter,
  TextField,
  SearchInput,
  FunctionField,
  ListProps,
  SelectInput,
  ReferenceField,
} from "react-admin";
import StatusField from "components/StatusField";
import { statusList } from "./const";
import ListWrapper from "../../components/ListWrapper";
import ListShowButton from "../../components/ListShowButton";
import ActionsMenu from "../../components/ActionsMenu";

const DriverFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput label="Status" source="Status" choices={statusList} alwaysOn />
  </Filter>
);

const DriverList = (props: ListProps) => {
  const breadcrumb = [{ link: "/drivers", title: "Drivers" }];

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="Drivers"
        isNotHaveSchoolFilter
        denseMode
        {...props}
        exporter={false}
        hasCreate={false}
        filters={<DriverFilter />}
        bulkActionButtons={false}
      >
        <Datagrid rowClick="show">
          <TextField source="id" emptyText="-" />
          <TextField source="fullName" emptyText="-" />
          <TextField source="contactNumber" emptyText="-" />
          <ReferenceField
            source="subcontractorId"
            label="Subcontractor"
            reference="subcontractors"
            emptyText="-"
            link="show"
          >
            <TextField source="name" />
          </ReferenceField>
          <StatusField source="status" />
          <FunctionField
            label="Actions"
            render={(record: any) => (
              <ActionsMenu render={[<ListShowButton record={record} />]} />
            )}
          />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default DriverList;
